interface ICaveatsProps {
    clientName: string;
}

const Caveats = (props: ICaveatsProps) => {

    const {clientName} = props;

    return (
        <article className="caveats">
            <h2 id="iv-caveats">IV. Caveats</h2>
            <p>
                This report has been prepared solely for the internal business use of and is only to be relied upon by the
                management of {clientName}. No portion of this report may be provided to any other party without Milliman’s
                prior written consent. In the event such consent is provided, the report must be provided in its entirety.
            </p>
            <p>
                In preparing this report, Milliman relied on data and other information provided by or on behalf of {clientName}. We have not audited or verified this data and information. If the underlying data or information is inaccurate or
                incomplete, this report may likewise be inaccurate or incomplete.
            </p>
            <p>
                Time and distance measures are estimates, and actual driving time and distance may vary based upon many factors
                including weather, traffic, route guidance, data timeliness, and other geographic factors which may impact the
                applicability of the calculated estimates used in this report.
            </p>
            <p>
                Due to variation and churn in provider data and its availability, this report may not be representative of the actual
                status of individual providers, their locations, specialties, or other characteristics at the time the data is published. We
                recommend this data be used as a guide only.
            </p>
            <p>
                Milliman recommends that the user of this information possess or be advised by professionals with expertise in health
                insurance operations so as not to misinterpret the information contained herein.
            </p>
        </article>
    );
};

export default Caveats;